module.exports = __webpack_public_path__ + "img/DST 1991.07d4bff1.jpg";